import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import programsEN from './locales/en/programs.json';
import impactEN from './locales/en/impact.json';
import partnersEN from './locales/en/partners.json';
import teamEN from './locales/en/team.json';
import fundersEN from './locales/en/funders.json';
import storiesEN from './locales/en/stories.json';
import volunteerEN from './locales/en/volunteer.json';
import donateEN from './locales/en/donate.json';
import contactEN from './locales/en/contact.json';

import commonHA from './locales/ha/common.json';
import homeHA from './locales/ha/home.json';
import programsHA from './locales/ha/programs.json';
import impactHA from './locales/ha/impact.json';
import partnersHA from './locales/ha/partners.json';
import teamHA from './locales/ha/team.json';
import fundersHA from './locales/ha/funders.json';
import storiesHA from './locales/ha/stories.json';
import volunteerHA from './locales/ha/volunteer.json';
import donateHA from './locales/ha/donate.json';
import contactHA from './locales/ha/contact.json';

import commonYO from './locales/yo/common.json';
import homeYO from './locales/yo/home.json';
import programsYO from './locales/yo/programs.json';
import impactYO from './locales/yo/impact.json';
import partnersYO from './locales/yo/partners.json';
import teamYO from './locales/yo/team.json';
import fundersYO from './locales/yo/funders.json';
import storiesYO from './locales/yo/stories.json';
import volunteerYO from './locales/yo/volunteer.json';
import donateYO from './locales/yo/donate.json';
import contactYO from './locales/yo/contact.json';

import commonIG from './locales/ig/common.json';
import homeIG from './locales/ig/home.json';
import programsIG from './locales/ig/programs.json';
import impactIG from './locales/ig/impact.json';
import partnersIG from './locales/ig/partners.json';
import teamIG from './locales/ig/team.json';
import fundersIG from './locales/ig/funders.json';
import storiesIG from './locales/ig/stories.json';
import volunteerIG from './locales/ig/volunteer.json';
import donateIG from './locales/ig/donate.json';
import contactIG from './locales/ig/contact.json';

import commonPID from './locales/pid/common.json';
import homePID from './locales/pid/home.json';
import programsPID from './locales/pid/programs.json';
import impactPID from './locales/pid/impact.json';
import partnersPID from './locales/pid/partners.json';
import teamPID from './locales/pid/team.json';
import fundersPID from './locales/pid/funders.json';
import storiesPID from './locales/pid/stories.json';
import volunteerPID from './locales/pid/volunteer.json';
import donatePID from './locales/pid/donate.json';
import contactPID from './locales/pid/contact.json';

export const supportedLanguages = {
  en: 'English',
  ha: 'Hausa',
  yo: 'Yoruba',
  ig: 'Igbo',
  pid: 'Nigerian Pidgin'
} as const;

export type SupportedLanguage = keyof typeof supportedLanguages;

const resources = {
  en: {
    common: commonEN,
    home: homeEN,
    programs: programsEN,
    impact: impactEN,
    partners: partnersEN,
    team: teamEN,
    funders: fundersEN,
    stories: storiesEN,
    volunteer: volunteerEN,
    donate: donateEN,
    contact: contactEN
  },
  ha: {
    common: commonHA,
    home: homeHA,
    programs: programsHA,
    impact: impactHA,
    partners: partnersHA,
    team: teamHA,
    funders: fundersHA,
    stories: storiesHA,
    volunteer: volunteerHA,
    donate: donateHA,
    contact: contactHA
  },
  yo: {
    common: commonYO,
    home: homeYO,
    programs: programsYO,
    impact: impactYO,
    partners: partnersYO,
    team: teamYO,
    funders: fundersYO,
    stories: storiesYO,
    volunteer: volunteerYO,
    donate: donateYO,
    contact: contactYO
  },
  ig: {
    common: commonIG,
    home: homeIG,
    programs: programsIG,
    impact: impactIG,
    partners: partnersIG,
    team: teamIG,
    funders: fundersIG,
    stories: storiesIG,
    volunteer: volunteerIG,
    donate: donateIG,
    contact: contactIG
  },
  pid: {
    common: commonPID,
    home: homePID,
    programs: programsPID,
    impact: impactPID,
    partners: partnersPID,
    team: teamPID,
    funders: fundersPID,
    stories: storiesPID,
    volunteer: volunteerPID,
    donate: donatePID,
    contact: contactPID
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: false // React already does escaping
    },

    react: {
      useSuspense: false
    },

    // Enable fallback to English for missing keys
    saveMissing: false,
    missingKeyHandler: (lng, ns, key) => {
      console.warn(`Missing translation key: ${key} for language: ${lng}, namespace: ${ns}`);
    }
  });

export default i18n;
